<template>
  <router-view />
  <PiniaColadaDevtools />
</template>

<script setup lang="ts">
import { PiniaColadaDevtools } from '@pinia/colada-devtools'
import { useAccountStore } from '@/stores/account'

const accountStore = useAccountStore()
accountStore.getMe()
</script>
